import { IAdditionalModalContext } from './additionalModalContext';

export enum AdditionalModalActionTypes {
	SET_ALL_DATA = 'SET_ALL_DATA',
	SET_ADDITIONAL_DISH_CATEGORY = 'SET_ADDITIONAL_DISH_CATEGORY',
	SET_ADDITIONAL_DISH_SUB_CATEGORY = 'SET_ADDITIONAL_DISH_SUB_CATEGORY',
	SET_FETCHED_ADDITIONAL_DISHES = 'SET_FETCHED_ADDITIONAL_DISHES',
	SET_ADDITIONAL_DISHES = 'SET_ADDITIONAL_DISHES',
}

interface ISetAllData {
	type: AdditionalModalActionTypes.SET_ALL_DATA;
	payload: {
		dishInfo: IAdditionalModalContext['dishInfo'];
		IDsSelectedRestaurant: IAdditionalModalContext['IDsSelectedRestaurant'];
		fetchedAdditionalDishes: IAdditionalModalContext['fetchedAdditionalDishes'];
		selectedAdditionalDishes: IAdditionalModalContext['selectedAdditionalDishes'];
	};
}

interface ISetAdditionalDishCategory {
	type: AdditionalModalActionTypes.SET_ADDITIONAL_DISH_CATEGORY;
	payload: {
		selectedAdditionalDishCategory: IAdditionalModalContext['selectedAdditionalDishCategory'];
	};
}

interface ISetAdditionalDishSubCategory {
	type: AdditionalModalActionTypes.SET_ADDITIONAL_DISH_SUB_CATEGORY;
	payload: {
		selectedAdditionalDishSubCategory: IAdditionalModalContext['selectedAdditionalDishSubCategory'];
	};
}

interface ISetFetchedAdditionalDishes {
	type: AdditionalModalActionTypes.SET_FETCHED_ADDITIONAL_DISHES;
	payload: {
		fetchedAdditionalDishes: IAdditionalModalContext['fetchedAdditionalDishes'];
	};
}

interface ISetAdditionalDishes {
	type: AdditionalModalActionTypes.SET_ADDITIONAL_DISHES;
	payload: {
		selectedAdditionalDishes: IAdditionalModalContext['selectedAdditionalDishes'];
	};
}

export type TAdditionalModalAction =
	| ISetAllData
	| ISetAdditionalDishCategory
	| ISetAdditionalDishSubCategory
	| ISetFetchedAdditionalDishes
	| ISetAdditionalDishes;
